/* fx-copy.js - store copy the app extension or a shared snippet hard codes.

   IT IS SAFE TO DO THIS HERE, AND THAT IS NOT TRUE OF EVERY STRING ON THIS
   STORE. A MutationObserver on the hero strapline recorded zero writes over a
   full session, so the extension renders it once and leaves it alone. Where
   the extension keeps rewriting a node, as it does with the selector bar
   label, competing with it produces a visible flicker and the answer is CSS.
   See the comment at the top of fx-ios.js for that recording.

   Every swap is guarded on the exact original string, so once the swap has
   happened the test stops matching and nothing writes again. A copy change on
   the extension side simply stops this from firing rather than fighting it.

   THE BACKORDER WORDING (29 Oct). The out of stock button said "Notify me
   when it's back" and the dialog promised to "email you the moment this part
   is available again". Nothing sends that email. Stock comes back through the
   nightly Cin7 push and no one is watching it per customer, so the promise
   was one the parts team could not keep and had no way of matching an old
   enquiry to a restock. Jonnie asked for the wording to say what actually
   happens: the request goes to a person. The HubSpot form was renamed to
   match on the same day.

   Note the two apostrophes are not the same character. The button carries a
   curly one, U+2019; the dialog title and sub carry straight ones. Guarding
   on the wrong one silently matches nothing, which is the failure mode this
   whole file is built around. */
(function () {
  'use strict';

  if (window.fxCopyOn) return;
  window.fxCopyOn = 1;

  var JOBS = [
    ['.vin-search-hero-store-sub',
     'Genuine Futura & SHIFTR trailer OEM parts, from Futura Trailers',
     'Genuine Futura & SHIFTR trailer parts'],

    ['.vin-check-notify__btn',
     'Notify me when it’s back',
     'Request Backorder'],

    ['.vcp-form__title',
     'Get notified when it\'s back',
     'Request a backorder'],

    ['.vcp-form__sub',
     'Leave your details and we\'ll email you the moment this part is available again.',
     'Tell us which parts you need and the parts team will come back to you with availability and a lead time.']
  ];

  /* querySelectorAll, not querySelector: the notify button is drawn once per
     product card, so the thumbnail scroller can hold several at a time. */
  function swap() {
    for (var i = 0; i < JOBS.length; i++) {
      var els = document.querySelectorAll(JOBS[i][0]);
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        var now = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (now === JOBS[i][1]) el.textContent = JOBS[i][2];
      }
    }
  }

  /* The dealer note in the cart footer reads "Dealer order. Our dealer trade
     terms apply.", where the middle three words are a link. The opening
     clause says nothing a dealer looking at their own cart does not already
     know, so it goes, and the link becomes the start of the sentence.

     Only the leading text node is removed. Rewriting the whole line with
     textContent would take the anchor with it, which is the part that has to
     survive. */
  function dealerNote() {
    var notes = document.querySelectorAll(
      '.fx-panel .fx-dealer-note, [data-fx-cart-foot] .fx-dealer-note, .fx-cart__foot .fx-dealer-note');
    for (var i = 0; i < notes.length; i++) {
      var n = notes[i];
      if (n.getAttribute('data-fx-copy')) continue;
      var first = n.firstChild;
      if (!first || first.nodeType !== 3) continue;
      if (!/^\s*Dealer order\.\s*Our\s*$/.test(first.nodeValue)) continue;
      n.removeChild(first);
      n.setAttribute('data-fx-copy', '1');
      var a = n.querySelector('a');
      if (a && /^\s*dealer trade terms\s*$/i.test(a.textContent || '')) {
        a.textContent = 'Dealer trade terms';
      }
    }
  }

  function pass() { swap(); dealerNote(); }

  function burst(delays) {
    for (var i = 0; i < delays.length; i++) setTimeout(pass, delays[i]);
  }

  function start() {
    pass();
    burst([400, 1600]);
    /* The cart panel is drawn on demand, so the note may not exist until the
       customer opens it. */
    document.addEventListener('fx:cart-changed', pass);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-fx-cart-open]')) burst([300, 1200]);
      /* The form dialog, and its title and sub, are built when the button is
         clicked, so the opening passes have nothing to find. The picker runs
         its own loop against the same dialog; both old and new titles read as
         a backorder to it, so the order the two land in does not matter. */
      if (t.closest('[data-vcp-form]')) burst([120, 400, 900, 1800]);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
